const state = {
  mobilesize: 992,
  smallsize: 768,
  isdevice: false,
  mobile: false,
  small: false,
  width: 0,
  height: 0,
  scrollheight: 0,
  progress: {
    status: 'stop',
    progress: 0,
    direction: 0,
    speed: 0
  }
}

export default state



// WEBPACK FOOTER //
// ./assets/js/store/modules/viewport/state.js